const percentColor = (number) => {
  return number < 33
    ? { color: "#FF0000" }
    : number >= 66
      ? { color: "#1BC200" }
      : { color: "#FFB800" };
};

const progressBarColor = (number) => {
  return number < 33
    ? { backgroundColor: "#FF0000" }
    : number >= 66
      ? { backgroundColor: "#1BC200" }
      : { backgroundColor: "#FFB800" };
};

const progressBarFloorColor = (number) => {
  return number < 33
    ? { backgroundColor: "#FF0000" }
    : number >= 66
      ? { backgroundColor: "#4A9BD4" }
      : { backgroundColor: "#FFB800" };
};

const percenFloortColor = (number) => {
  return number < 33
    ? { color: "#FF0000" }
    : number >= 66
      ? { color: "#4A9BD4" }
      : { color: "#FFB800" };
};
const progressBarMainFloorColor = (number) => {
  return number < 33
    ? { backgroundColor: "#FF0000" }
    : number >= 66
      ? { backgroundColor: "#1BC200" }
      : { backgroundColor: "#FFB800" };
};
const percenFloortMainColor = (number) => {
  return number < 33
    ? { color: "#FF0000" }
    : number >= 66
      ? { color: "#1BC200" }
      : { color: "#FFB800" };
};

export {
  percentColor,
  progressBarColor,
  progressBarFloorColor,
  percenFloortColor,
  progressBarMainFloorColor,
  percenFloortMainColor,
};
